<template>
  <div class="divider">
  </div>
</template>

<script>
	export default {
		name: "Divider",

		data: () => ({
				//
		})
	};
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.divider {
  height: 70px;
  background-color: $gray2;
}

/* Vuetify xs = extra-small */
@media only screen and (max-width: 600px) {
  .divider {
    height: 30px;
  }
}
</style>